// extracted by mini-css-extract-plugin
module.exports = {"page-account-enterprise-p4":"P4_page-account-enterprise-p4__RcZYd","pageAccountEnterpriseP4":"P4_page-account-enterprise-p4__RcZYd"};